import Reveal from "@/components/base/Reveal";
import { compareColumns, compareRows } from "@/mocks/home";

export default function VersionCompare() {
  return (
    <section id="compare" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
              Comparison
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              原声＋中文字幕 与 国语版对比
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              两种选择没有绝对优劣，差别主要体现在对白语言、阅读负担以及注意力如何分配。下表按常见维度做对照，
              方便你按场景决定。
            </p>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-10 overflow-hidden rounded-lg border border-background-200">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[640px] border-collapse text-left">
                <caption className="sr-only">原声加中文字幕与国语版中文配音的对比</caption>
                <thead>
                  <tr className="bg-secondary-100">
                    {compareColumns.map((col, index) => (
                      <th
                        key={col}
                        scope="col"
                        className={`px-5 py-4 font-heading text-sm font-bold ${
                          index === 0 ? "text-foreground-800" : "text-primary-800"
                        }`}
                      >
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {compareRows.map((row, index) => (
                    <tr
                      key={row.item}
                      className={`border-t border-background-200 ${
                        index % 2 === 0 ? "bg-background-50" : "bg-background-100"
                      }`}
                    >
                      <th scope="row" className="px-5 py-4 text-sm font-semibold text-foreground-900">
                        {row.item}
                      </th>
                      <td className="px-5 py-4 text-sm text-foreground-600">{row.original}</td>
                      <td className="px-5 py-4 text-sm text-foreground-600">
                        <span className="inline-flex items-center gap-2">
                          <i className="ri-mic-line text-accent-600" aria-hidden="true"></i>
                          {row.dubbed}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>

        <Reveal delay={140}>
          <div className="mt-8 grid gap-5 md:grid-cols-2">
            <div className="rounded-lg border border-primary-200 bg-primary-50 p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-primary-800">
                <i className="ri-volume-up-line" aria-hidden="true"></i>
                选原声＋中文字幕，如果
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                你希望保留原始语气、环境音与配乐层次，并且能在安静环境下专注阅读字幕。
              </p>
            </div>
            <div className="rounded-lg border border-accent-300 bg-accent-50 p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-accent-800">
                <i className="ri-mic-line" aria-hidden="true"></i>
                选国语版，如果
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                你不便持续阅读字幕，或需要在多任务状态下观看，希望只靠听觉就能跟上对白。
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}